import { Store } from '@ngrx/store';
import {
  MyPurchaseForm,
  IBudgetAllocForm,
  BudgetAllocationSummary,
  IItemToRequest,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { Component, ViewChild, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import {
  Observable,
  Subject,
  takeUntil,
  lastValueFrom,
  asapScheduler,
  firstValueFrom,
  skip,
} from 'rxjs';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DropDownOptions } from 'src/app/shared/models/app-models/DropDownOption.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import {
  updateApprovingOfficer,
  updateApprovingOfficerRequired,
} from 'src/app/core/store/form.actions';
import * as _ from 'lodash';
import { DecimalPipe } from '@angular/common';
import { BaseTableColumn } from 'src/app/shared/models/app-models/BaseTableColumn.model';
import { MatSelectChange } from '@angular/material/select';
import { MatTabGroup } from '@angular/material/tabs';
import { getApprovingPersonnelOptions, getOperatingBudgetAllocations, getProjectBudgetAllocations } from 'src/app/modules/shared/utils/derive-budget-allocations';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { doesNotMeetRfsCriteria } from 'src/app/modules/shared/utils/check-rfs-criteria';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { StoreDropdowns } from 'src/app/shared/models/app-models/StoreDropdowns.model';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { InfoDialogComponent } from 'src/app/shared/components/info-dialog/info-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CapitalUsageReqSummaryComponent } from './capital-usage-req-summary/capital-usage-req-summary.component';
import { auto } from '@popperjs/core';
import { CurrencyService } from "src/app/shared/services/currency.service"
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-budget-summary',
  templateUrl: './budget-summary.component.html',
  styleUrls: ['./budget-summary.component.scss'],
  providers: [
    {
      provide: DecimalPipe,
    },
  ],
})

export class BudgetSummaryComponent implements OnDestroy {
  @ViewChild(MatTable) table: MatTable<any> | undefined;
  @Input() isReadOnly = false
  totalBudgetCost: number = 0
  allBudgetAllocationForms: IBudgetAllocForm[] = [];
  operatingBudgetAllocations: BudgetAllocationSummary[] = [];
  capitalBudgetAllocations: BudgetAllocationSummary[] = [];
  captialAUCBudgetAllocations: BudgetAllocationSummary[] = [];
  projectBudgetAllocations: BudgetAllocationSummary[] = [];
  projectBudgetDataSource!: MatTableDataSource<BudgetAllocationSummary>;
  projectDisplayColumns!: string[];
  rfsOutcomeResults?: RfsSourcingResponse;
  deactivatedItems: IItemToRequest[] = [];
  
  permissionData$: Observable<any>
  storeDropdowns?: StoreDropdowns;
  selectedTabIndex: number = 0;
  wholeForm!: MyPurchaseForm;
  form!: MyPurchaseForm['ItemList'];
  genForm!: MyPurchaseForm['generalForm'];
  currencyExchangeRates: CurrencyExchange[] = []
  currencyRates$: Observable<CurrencyExchange[]>;
  store$: Observable<MyPurchaseForm>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  loading: boolean = true;
  updateAO: boolean = false;
  noErr: boolean = true
  documentStatusId: number = 0;
  exchangeRateLock: boolean = false;
  noDataMessage: string = "You have no record for this budget type.";
  oldProjectCodes: Array<string> = [];
  
  capitalAUCColumns: BaseTableColumn<BudgetAllocationSummary>[] = [
    {
      columnDef: 'view',
      header: 'Capital usage req.',
      cell: (element: BudgetAllocationSummary) => ``,
      onClick: (element: BudgetAllocationSummary) => this.openDialog(element.displayPurchaseItemNumber)
    },
    {
      columnDef: 'projectBudget',
      header: 'Project budget',
      cell: (element: BudgetAllocationSummary) => `${element.projectBudget}`,
    },
    {
      columnDef: 'glAccount',
      header: 'G/L account',
      cell: (element: BudgetAllocationSummary) => `${element.glAccount}`,
    },
    {
      columnDef: 'itemNo',
      header: 'Item no.',
      cell: (element: BudgetAllocationSummary) => `${element.displayPurchaseItemNumber}`,
    },
    {
      columnDef: 'expenditure',
      header: 'Expenditure',
      cell: (element: BudgetAllocationSummary) => `${element.budgeted}`,
    },
    {
      columnDef: 'amount',
      header: 'AOR amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.totalAmount, '1.2') ?? '0.00'}`,
    },
  ];

  projectColumns: BaseTableColumn<BudgetAllocationSummary>[] = [
    {
      columnDef: 'approvingPersonnel',
      header: 'Approving personnel',
      cell: (element: BudgetAllocationSummary) => '',
    },
    {
      columnDef: 'projectCode',
      header: 'Project Code',
      cell: (element: BudgetAllocationSummary) => `${element.projectCode}`,
    },
    {
      columnDef: 'projectBudget',
      header: 'Project budget',
      cell: (element: BudgetAllocationSummary) => `${element.projectBudget}`,
    },
    {
      columnDef: 'glAccount',
      header: 'G/L account',
      cell: (element: BudgetAllocationSummary) => `${element.glAccount}`,
    },
    {
      columnDef: 'itemNo',
      header: 'Item no.',
      cell: (element: BudgetAllocationSummary) => `${element.displayPurchaseItemNumber}`,
    },
    {
      columnDef: 'amount',
      header: 'AOR amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.aorAmount, '1.2') ?? '0.00'}`,
    },
    {
      columnDef: 'totalAmount',
      header: 'Total amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.totalAmount, '1.2') ?? '0.00'}`,
    }
  ];

  operatingColumns: BaseTableColumn<BudgetAllocationSummary>[] = [
    {
      columnDef: 'CostCentre',
      header: 'Cost Centre',
      cell: (element: BudgetAllocationSummary) => `${element.costCentre}`,
    },
    {
      columnDef: 'GLAcc',
      header: 'G/L Account',
      cell: (element: BudgetAllocationSummary) => `${element.glAccount}`,
    },
    {
      columnDef: 'OrderNo',
      header: 'Order No.',
      cell: (element: BudgetAllocationSummary) => `${element.orderNo}`,
    },

    {
      columnDef: 'Expenditure',
      header: 'Expenditure',
      cell: (element: BudgetAllocationSummary) => `${element.budgeted}`,
    },
    {
      columnDef: 'BudgetFrequencyUsage',
      header: 'Recurrent',
      cell: (element: BudgetAllocationSummary) => `${element.reccurent}`,
    },
    {
      columnDef: 'BudgetItemId',
      header: 'Item no.',
      cell: (element: BudgetAllocationSummary) => `${element.displayPurchaseItemNumber}`,
    },
    {
      columnDef: 'ProjectBudget',
      header: 'Total Amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.totalAmount, '1.2') ?? '0.00'}`,
    },
    {
      columnDef: 'aorExemptedAmount',
      header: 'AOR exempted amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.aorExemptedAmount, '1.2') ?? '0.00'}`,
    },
    {
      columnDef: 'aorAmount',
      header: 'AOR amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.aorAmount, '1.2') ?? '0.00'}`,
    },
  ];

  capitalColumns: BaseTableColumn<BudgetAllocationSummary>[] = [
    {
      columnDef: 'view',
      header: 'Capital usage req.',
      cell: (element: BudgetAllocationSummary) => ``,
      onClick: (element: BudgetAllocationSummary) => this.openDialog(element.displayPurchaseItemNumber)
    },
    {
      columnDef: 'fundCentre',
      header: 'Fund Centre',
      cell: (element: BudgetAllocationSummary) => `${element.fundCentre}`,
    },
    {
      columnDef: 'glAccount',
      header: 'G/L account',
      cell: (element: BudgetAllocationSummary) => `${element.glAccount}`,
    },
    {
      columnDef: 'itemNo',
      header: 'Item no.',
      cell: (element: BudgetAllocationSummary) => `${element.displayPurchaseItemNumber}`,
    },
    {
      columnDef: 'expenditure',
      header: 'Expenditure',
      cell: (element: BudgetAllocationSummary) => `${element.budgeted}`,
    },
    {
      columnDef: 'amount',
      header: 'AOR amount',
      cell: (element: BudgetAllocationSummary) =>
        `${this.decimalPipe.transform(element.totalAmount, '1.2') ?? '0.00'}`,
    },
  ];

  constructor(
    private store: Store<{ form: MyPurchaseForm, dp: StoreDropdowns, currency: CurrencyExchange[] }>,
    private BackendApi: BackendApiService,
    private decimalPipe: DecimalPipe,
    private transformer: FormTransformerPipe,
    private backendService: BackendApiService,
    private permissionService:PermissionsService,
    private dialog: MatDialog,
    private currencyService: CurrencyService,
    private sanitizer: DomSanitizer
  ) {
    this.currencyRates$ = this.store.select('currency')
    this.currencyRates$.pipe(takeUntil(this.destroy$)).subscribe((currency: CurrencyExchange[]) => {
      this.currencyExchangeRates = currency
    })
    this.store$ = this.store.select('form');
    this.permissionData$ = permissionService.getService()
    this.projectDisplayColumns = this.projectColumns.map((c) => c.columnDef);
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.storeDropdowns = dp;
      });
    this.store$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        if (this.updateAO) {
          return;
        }
        this.loading = true;
        this.genForm = form.generalForm as MyPurchaseForm['generalForm'];
        const transformedData = this.transformArray();
        this.projectBudgetDataSource =
          new MatTableDataSource<BudgetAllocationSummary>(
            transformedData
          );
        try {
          this.form = await this.convertItemPricesToSGD(form.ItemList as MyPurchaseForm['ItemList']);
          if (this.deactivatedItems.length > 0) {
            this.form = await this.convertItemPricesToSGD(this.deactivatedItems as MyPurchaseForm['ItemList']);
          }
          console.log(this.form, 'for budget');
          this.wholeForm = form as MyPurchaseForm;
          this.documentStatusId = form.documentStatusId;
          this.exchangeRateLock = form.ExchangeRateLock;
          this.form = this.form.filter((item) => !item.isDeleted);
          this.form = this.form.filter((item) => !item.isDeleted);
          this.allBudgetAllocationForms = this.form.flatMap((item) =>
            item.BudgetAllocation.filter((budget) => budget.isDeleted == false)
          );
          this.operatingBudgetAllocations = getOperatingBudgetAllocations(
            this.allBudgetAllocationForms, this.form
          );
          this.capitalBudgetAllocations = this.getCapitalBudgetAllocations(
            this.allBudgetAllocationForms
          );
          this.captialAUCBudgetAllocations = this.getCapitalAUCAllocations(
            this.allBudgetAllocationForms
          );

          let newProjectCodes: Array<string> = [];
          this.allBudgetAllocationForms.forEach((item) => {
            if (item.ProjectCode?.id != null) {
              newProjectCodes.push(item.ProjectCode.id);
            }
          });
          
          // only when projectcodes changed
          if(JSON.stringify(this.oldProjectCodes) != JSON.stringify(newProjectCodes)) {
            const results = await Promise.all(
              getProjectBudgetAllocations(this.allBudgetAllocationForms, this.form, this.backendService, this.genForm)
            )
            this.oldProjectCodes = newProjectCodes;
  
            this.updateAO = true;
            if (results) {
              this.projectBudgetAllocations = results;
              this.projectBudgetDataSource.data = this.transformArray();
              for (const projBudget of this.projectBudgetAllocations) {
                if (projBudget.personnel) {
                  this.updateApprovingOfficer(projBudget.personnel);
                }
              }
            }
            this.shouldShowPersonnelAlert();
            this.updateAO = false;
            this.totalBudgetCost = this.calculateBudgetAllocationAmount()
            this.noErr = true
          }
        }
        catch (error: unknown) {
          console.error(error)
          this.noErr = false
        }
        finally {
          this.loading = false;
        }
      });
  }
  async ngOnInit() {
    // this.storeDropdowns = await firstValueFrom(
    //   this.store.select('dp').pipe(skip(1))
    // );
  }

  transformArray(): BudgetAllocationSummary[] {
    const grouped = this.projectBudgetAllocations.reduce((acc: { [key: string]: any }, curr) => {
      if (!acc[curr.projectCode]) {
        acc[curr.projectCode] = {
          ...curr,
          projectBudget: '',
          glAccount: '',
          displayPurchaseItemNumber: '',
          aorAmount: '',
          totalAmount: 0,
          Strikethrough: true,
          personnelOptions: [],
        };
      }
        const strikethroughStyle = curr.Strikethrough ? 'style="text-decoration: line-through; color: grey;"' : '';
      const uniquePersonnelOptions = [
        ...acc[curr.projectCode].personnelOptions,
        ...(curr.personnelOptions || [])
      ]
        .filter((value, index, self) => 
          index === self.findIndex((t) => t.id === value.id) 
        );
  
      if (uniquePersonnelOptions.length !== acc[curr.projectCode].personnelOptions.length) {
        acc[curr.projectCode].personnelOptions = uniquePersonnelOptions;
    }
  
      // Concatenate projectBudget with the <span> tag and line-through style if needed
      acc[curr.projectCode].projectBudget += `<span ${strikethroughStyle}>${curr.projectBudget}</span> <br>`;
      acc[curr.projectCode].glAccount += `<span ${strikethroughStyle}>${curr.glAccount}</span> <br>`;
      acc[curr.projectCode].displayPurchaseItemNumber += `<span ${strikethroughStyle}>${curr.displayPurchaseItemNumber}</span> <br>`;
      acc[curr.projectCode].aorAmount += `<span ${strikethroughStyle}>${curr.aorAmount}</span> <br>`;
      acc[curr.projectCode].totalAmount += !curr.Strikethrough ? Number(curr.totalAmount) : 0;
  
      // Accumulate Strikethrough (it should be true if all are true, otherwise false)
      acc[curr.projectCode].Strikethrough = acc[curr.projectCode].Strikethrough && curr.Strikethrough;
      if (!curr.Strikethrough && curr.displayPurchaseItemNumber) {
        if (acc[curr.projectCode].itemNumbers) {
          // If itemNumbers already has values, append with a comma
          acc[curr.projectCode].itemNumbers += `,${curr.displayPurchaseItemNumber}`;
        } else {
          // If it's the first item, just set itemNum without the leading comma
          acc[curr.projectCode].itemNumbers = curr.displayPurchaseItemNumber;
          if(curr.personnelOptions && curr.personnel && curr.personnel) {
            
            if(typeof curr.personnel == "object") {
              const personnel: DropDownOptions = curr.personnel as DropDownOptions;
              acc[curr.projectCode].personnelOptions = curr.personnelOptions;
              acc[curr.projectCode].personnel = curr.personnelOptions.find((item) => item.id == personnel.id);;
            }
          }
        }
      }
  
      return acc;
    }, {});


  
    console.log('Grouped Data:', grouped);
  
    // Bypass Security for HTML content and return the updated array
    Object.keys(grouped).forEach(projectCode => {
      grouped[projectCode].projectBudget = this.sanitizer.bypassSecurityTrustHtml(grouped[projectCode].projectBudget);
      grouped[projectCode].glAccount = this.sanitizer.bypassSecurityTrustHtml(grouped[projectCode].glAccount);
      grouped[projectCode].displayPurchaseItemNumber = this.sanitizer.bypassSecurityTrustHtml(grouped[projectCode].displayPurchaseItemNumber);
      grouped[projectCode].aorAmount = this.sanitizer.bypassSecurityTrustHtml(grouped[projectCode].aorAmount);
    });
  
    // Return the grouped array as an array of BudgetAllocationSummary
    return Object.values(grouped);
  }
  

  
  

  openDialog(displayItem: string): void {
    this.dialog.open(CapitalUsageReqSummaryComponent, {
      width: '950px',
      maxHeight: '85vh',
      data: {
        selectedCapitalReqUsage: displayItem,
      }
    });
  }
  calculateBudgetAllocationAmount() {
    let amount = 0
    this.operatingBudgetAllocations.forEach(x => {
      amount += Number(x.totalAmount)
    })
    this.capitalBudgetAllocations.forEach(x => {
      amount += x.totalAmount
    })
    this.captialAUCBudgetAllocations.forEach(x => {
      amount += x.totalAmount
    })
    this.projectBudgetAllocations.forEach(x => {
      amount += x.totalAmount
    })
    return amount
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async convertCurrencyToSGD(amount: number, currCode: string, exchangeRateCurrency: number) {
    if (currCode == 'SGD') return amount
    let currEx = this.currencyExchangeRates.find(x => x.FromCurrency == currCode)
    if (!currEx) {
      const resp: CurrencyExchange = await lastValueFrom(this.backendService.getCurrencyExchange(currCode));
      currEx = resp
      this.store.dispatch(addCurrencyExchange({ currency: resp }))
    }
    let exchangeRate;
    if(this.exchangeRateLock){
      exchangeRate = exchangeRateCurrency;
      }else if(this.documentStatusId === 0 || this.documentStatusId === 2 || this.documentStatusId === 3 || this.documentStatusId === 6){
        exchangeRate = currEx!.Rate;
      }else{
        exchangeRate = exchangeRateCurrency;
    }
    if (!exchangeRate) throw new Error('Unable to convert selected currency to SGD')
    return (amount * (exchangeRate / currEx.RatioForTheFromCurrencyUnits))
  }
  async convertItemPricesToSGD(itemList: IItemToRequest[]) {
    let updatedItemList: IItemToRequest[] = []
    for (const item of itemList) {
      console.log('convertItemPricesToSGD item', item)
      let newItem = structuredClone(item)
      let price = newItem.ItemPrice.UnitPrice
      let currCode = newItem.ItemPrice.Currency.value
      if (price && currCode) {
        let convertedPrice = await this.currencyService.convertAsyncCurrencyToSGD(price, currCode,item.ItemPrice.ExchangeRate) ?? 0;
        newItem.ItemPrice.UnitPrice = convertedPrice
      }
      updatedItemList.push(newItem)
    }
    return updatedItemList
  }
  getCapitalAUCAllocations(
    allBudgetAllocationForms: IBudgetAllocForm[]
  ): BudgetAllocationSummary[] {
    let itemIdList = this.form
      .filter(x => !x.isDeleted)
      .map(x => x.AddItems.itemId)
      .sort((a, b) => a - b);
    let budgetGroup = _.groupBy(
      allBudgetAllocationForms.filter(
        (s) => s.BudgetType.value === 'Capital AUC' && !s.isDeleted
      ),
      (allo) =>
        (allo.BudgetExpenditureUsage?.value ?? '') +
        (allo.ProjectBudget?.id ?? '') + allo.Strikethrough
    );

    let result = _.map(budgetGroup, (allocation, key) => {
      let totalAmount = allocation.reduce((sum, allo) => {
        let item = this.form.find(x => x.AddItems.itemId == allo.PurchaseItemNo as number);


        if (!item) return sum;

        if (allo.Quantity) {
          return (
            sum +
            (allo.Quantity * item.ItemPrice.UnitPrice) /
            item.ItemPrice.UnitsPerQuantity
          );
        } else {
          return (
            sum +
            ((allo.Percentage ?? 1) *
              ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) /
                item.ItemPrice.UnitsPerQuantity)) /
            100
          );
        }
      }, 0);

      const glAccountString = allocation
        .map(allo => allo.GLAcc?.value)
        .filter((value, index, self) => self.indexOf(value) === index).
        join(', ');

      const purchaseItemNo = allocation
        .map(allo => allo.PurchaseItemNo)
        .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
        .join(', ');
      const displayedItemNo = allocation
        .map(allo => allo.displayPurchaseItemNumber).join(', ');

      return {
        budgetType: allocation[0].BudgetType?.value ?? '',
        glAccount: glAccountString,
        budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
        percentage: allocation.reduce(
          (sum, allo) => sum + (allo.Percentage ?? 1),
          0
        ),
        id: purchaseItemNo,
        totalAmount: Math.round(totalAmount * 100) / 100,
        projectBudget: allocation[0].ProjectBudget?.value ?? '',
        fundCentre: '',
        costCentre: '',
        orderNo: '',
        reccurent: '',
        budgetId: '',
        projectCode: '',
        personnel: '',
        aorExemptedAmount: 0,
        aorAmount: 0,
        personnelOptions: undefined,
        Strikethrough: allocation[0].Strikethrough,
        displayPurchaseItemNumber: displayedItemNo,
        wbsElement:allocation[0].ProjectBudget?.id ?? '',
      };
    });

    return result;
  }

  getCapitalBudgetAllocations(
    allBudgetAllocationForms: IBudgetAllocForm[]
  ): BudgetAllocationSummary[] {
    let itemIdList = this.form.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort((a, b) => a - b);
    let budgetGroup = _.groupBy(
      allBudgetAllocationForms.filter((s) => s.BudgetType.value === 'Capital' && !s.isDeleted),
      (allo) =>
        (allo.FundCentre?.value ?? '') +
        (allo.OrderNo?.value ?? '') +
        (allo.BudgetExpenditureUsage?.value ?? '') + (allo.Strikethrough)
    );

    let result = _.map(budgetGroup, (allocation, key) => {
      let totalAmount = allocation.reduce((sum, allo) => {
        let item = this.form.find(x => x.AddItems.itemId == allo.PurchaseItemNo as number);

        if (!item) return sum;

        if (allo.Percentage) {
          return (
            sum +
            (allo.Percentage *
              ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) /
                item.ItemPrice.UnitsPerQuantity)) /
            100
          );
        } else {
          return (
            sum +
            ((allo.Quantity ?? 0) * item.ItemPrice.UnitPrice) /
            item.ItemPrice.UnitsPerQuantity
          );
        }
      }, 0);

      const glAccountString = allocation
        .map(allo => allo.GLAcc?.value)
        .filter((value, index, self) => self.indexOf(value) === index).
        join(', ');

      const purchaseItemNo = allocation
        .map(allo => allo.PurchaseItemNo)
        .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
        .join(', ');
      const displayedPurchaseItemNo = allocation
        .map(allo => allo.displayPurchaseItemNumber).join(', ');
      return {
        budgetType: allocation[0].BudgetType?.value ?? '',
        costCentre: allocation[0].CostCentre?.value ?? '',
        glAccount: glAccountString,
        orderNo: allocation[0].OrderNo?.value ?? '',
        budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
        reccurent: allocation[0].BudgetFrequencyUsage?.value ?? '',
        percentage: allocation.reduce(
          (sum, allo) => sum + (allo.Percentage ?? 1),
          0
        ),
        id: purchaseItemNo,
        projectBudget: '',
        totalAmount: Math.round(totalAmount * 100) / 100,
        fundCentre: allocation[0].FundCentre?.value ?? '',
        budgetId: '',
        projectCode: '',
        aorExemptedAmount: 0,
        aorAmount: Math.round(totalAmount * 100) / 100,
        personnel: '',
        personnelOptions: undefined,
        Strikethrough: allocation[0].Strikethrough,
        displayPurchaseItemNumber: displayedPurchaseItemNo,
        wbsElement: allocation[0].ProjectBudget?.id ?? ''
      };
    });

    return result;
  }


  shouldShowPersonnelAlert() {
    if (
      this.projectBudgetAllocations &&
      this.projectBudgetAllocations.some(
        (c) => !c.Strikethrough && !c.personnel && c.totalAmount > 6000
      )
    ) {
      if (!this.wholeForm.isProjectRORequired) {
        asapScheduler.schedule(() =>
          this.store.dispatch(
            updateApprovingOfficerRequired({ isRequired: true })
          )
        );
        this.selectedTabIndex = 3; // Set it to the index of the "Project" tab
      }
      return true;
    } else {
      this.store.dispatch(updateApprovingOfficerRequired({ isRequired: false }))
    }
    return false;
  }

  onApprovalSelectionChange(event: any, row: any) {
    let selected = event.value;
    row.personnel=selected;
    const updatedAllocations = this.projectBudgetAllocations.map((allocation) => {
      if (allocation.projectCode === row.projectCode) {
        return {
          ...allocation, 
          personnel: selected
        };
      }
      return allocation; 
    });
      this.projectBudgetAllocations = updatedAllocations;
    this.transformArray();
    this.store.dispatch(
      updateApprovingOfficer({
        approvingOfficer: selected.id,
        itemNo: selected.item,
        budgetInfo: selected.budget,
      })
    );
    this.store.dispatch(updateApprovingOfficerRequired({ isRequired: false }));
  }

  updateApprovingOfficer(data: any) {
    this.store.dispatch(updateApprovingOfficer({
      approvingOfficer: data.id,
      itemNo: data.item,
      budgetInfo: data.budget,
    }))
  }

  displayApprovingOfficer(option: any) {
    return option ? option : '';
  }
}
